import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/app/index.scss'
import App from '@/app/App'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { Main } from '@/page/Main/Main.jsx'

require('sass')

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                element: <Main />,
            },
        ],
    },
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<RouterProvider router={router} />)
